"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleLogger = exports.prefixLogger = exports.noopLogger = void 0;
var noopLogger = function () {
    /*noop*/
};
exports.noopLogger = noopLogger;
var prefixLogger = function (prefix, logger) {
    if (logger === exports.noopLogger) {
        return exports.noopLogger;
    }
    else {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return logger.apply(void 0, __spreadArray([prefix + ":: "], args, false));
        };
    }
};
exports.prefixLogger = prefixLogger;
exports.consoleLogger = console.log;
//# sourceMappingURL=logger.js.map